// extracted by mini-css-extract-plugin
export default {"inputWrapper":"ModalAuthRegInput_inputWrapper__Ydarh","error":"ModalAuthRegInput_error__jGJYW"};